import { gsap } from "gsap";
import { DrawSVGPlugin } from "../../plugins/gsap/DrawSVGPlugin";
import { SplitText} from "../../plugins/gsap/SplitText";

gsap.registerPlugin(DrawSVGPlugin, SplitText);

class Hero16Minutes {

    constructor() {
        this.typingAnimation();
        this.lineAnimation();
    }

    typingAnimation() {
        this.animatedText = document.querySelector('#sixteen-minutes-hero .animated-txt ');
        this.SplitText = new SplitText(this.animatedText, {type:"chars, words, lines"});
        gsap.set(this.SplitText.chars, {display:'none'});
        gsap.set(this.animatedText, {alpha:1});
        this.tl = gsap.timeline({delay:2});
        this.tl
        .to(this.SplitText.chars, {duration:1, display:'inline-block', 
        stagger: {
                each: 0.15,
                from: "start",
                ease:`steps(${this.SplitText.chars.length}))`
        }});
    }

    lineAnimation() {
        gsap.timeline(
            {
            delay:0.5,
            defaults: {
                duration: 1,
                ease:'steps(24)', //24fps
            }
        })
        .set('.a16zLogo16minutes-a', {alpha:1}) 
        .fromTo('.a16zLogo16minutes-a', {drawSVG: '100% 100%'}, {drawSVG: true})
    }

}

export {Hero16Minutes as default}